export const ORDINAL_OUTPOINT_RE = /^[0-9a-f]{64}_[0-9]+$/i
const HEX_64_RE = /^[0-9a-f]{64}$/i

const cleanHost = (hostname: string) => hostname.replace(/^(www\.)?/, '')

export function isOrdinalOutpoint(value?: string | null): boolean {
    return ORDINAL_OUTPOINT_RE.test(String(value || '').trim())
}

export function extractOrdinalOutpointFromUrl(url: string): string | null {
    try {
        const u = new URL(url)
        const host = cleanHost(u.hostname)
        const path = u.pathname.replace(/\/+$/, '')

        if (host === 'ordfs.network' || host === 'ordinals.gorillapool.io') {
            const outpoint = (path.split('/').pop() || '').trim()
            if (isOrdinalOutpoint(outpoint)) return outpoint

            const txidOnlyContent = path.match(/^\/content\/([0-9a-f]{64})$/i)
            if (host === 'ordinals.gorillapool.io' && txidOnlyContent?.[1]) {
                return `${txidOnlyContent[1]}_0`
            }

            return null
        }

        if (host === '3dordi.io') {
            const match = path.match(/^\/(?:ordinal|collection)\/([^\/]+)$/i)
            const outpoint = (match?.[1] || '').trim()
            return isOrdinalOutpoint(outpoint) ? outpoint : null
        }
    } catch {}

    return null
}

export function isCanonicalOrdinalContentUrl(url: string): boolean {
    try {
        const u = new URL(url)
        const host = cleanHost(u.hostname)
        return host === 'ordfs.network' || host === 'ordinals.gorillapool.io'
    } catch {}

    return false
}

export function isGorillaPoolContentTxidUrl(url: string): boolean {
    try {
        const u = new URL(url)
        const host = cleanHost(u.hostname)
        if (host !== 'ordinals.gorillapool.io') return false

        const path = u.pathname.replace(/\/+$/, '')
        const match = path.match(/^\/content\/([0-9a-f]{64})$/i)
        return !!(match?.[1] && HEX_64_RE.test(match[1]))
    } catch {}

    return false
}

export function normalizeThreeDOrdiContentUrl(url?: string | null): string | null {
    if (!url) return null

    const outpoint = extractOrdinalOutpointFromUrl(url)
    if (!outpoint) return null

    try {
        const u = new URL(url)
        if (cleanHost(u.hostname) !== '3dordi.io') return null
    } catch {
        return null
    }

    return `https://ordinals.gorillapool.io/content/${outpoint}`
}
